export const AppRoutesRouter = {
  Home: 'locality',
  Login: '/login',
  UserRegistration: '/register/:code',
  MapPage: '/map/:customerId/:localityId',
  ProjectMap: '/map/:customerId/:localityId/:projectId',
  Profile: '/profile',
  RegisterComplete: '/register/complete',
  UnAuth: '/unauth',
  Localities: {
    main: 'locality',
    basePath: 'localities/customer/:customerId/locality/:localityId/*',
    sidebarPath: 'localities/customer/:customerId/locality/:localityId/*',
    locality: '',
    deviations: 'deviations/*',
    deviation: 'deviations/:deviationId',
    componentDeviation: 'moorings/:mooringId/positions/:positionId/components/:componentId/deviations',
    documents: 'documents/*',
    document: 'documents/:documentId',
    mainComponent: 'equipment/:mainComponentId',
    mooringsNew: 'mooring-new/*',
    moorings: 'moorings/*',
    mooringDashboard: 'moorings/dashboard',
    mooringList: 'moorings/list',
    mooring: 'moorings/:mooringId',
    positions: 'moorings/:mooringId/positions',
    position: 'moorings/:mooringId/positions/:positionId',
    createPosition: 'moorings/:mooringId/position/create',
    localityServices: 'locality-services/*',
    localityService: 'locality-services/:localityFrequencyId',
    localityServiceGroup: 'locality-services-group/:groupId',
    workAssignments: 'work-assignments/*',
    workAssignment: 'work-assignments/:workAssignmentId',
    equipment: 'equipment/*',
    workOrders: 'work-orders/*',
    workOrder: 'work-orders/:workOrderId',
    equipmentPerformedMaintenances: 'equipment-performed-maintenances/*',
    localityPerformedMaintenances: 'locality-performed-maintenances/*',
  },
  Boats: '/boats',
  serviceStation: {
    main: '/service-station',
    basePath: '/service-stations/customer/:customerId/service-station/:serviceStationId/*',
    sidebarPath: '/service-stations/customer/:customerId/service-station/:serviceStationId/*',
    deviation: 'deviations/:deviationId',
    documents: 'documents/:documentId',
    dashboard: '',
    mainComponent: 'equipment/:mainComponentId',
    certifications: 'certifications',
    history: 'history',
  },
  storage: {
    main: '/storage',
    basePath: '/storages/customer/:customerId/storage/:storageId/*',
    sidebarPath: '/storages/customer/:customerId/storage/:storageId/*',
    deviation: 'deviations/:deviationId',
    documents: 'documents/:documentId',
    dashboard: '',
  },
  Map: '/map',
  Admin: {
    basePath: '/admin/*',
    customers: 'customers',
    createCustomer: 'customers/create',
    updateCustomer: 'customers/:id',
    materialFactor: 'material-factor',
    deviations: 'deviations',
    users: 'all-users',
    accessControl: 'access-control',
    deviation: 'deviations/:deviationId',
    product: 'product',
    productCategory: 'productCategory',
    supplier: 'supplier',
    customerUsers: 'customers/:id/users',
    customerUserResources: 'customers/:id/users/:userId/resources',
    sensorType: 'sensor-type',
    distributor: 'distributor',
    positionDrawing: 'position-drawing',
    documentCategory: 'document-category',
    auditLogs: 'audit-logs',
    customProperty: 'custom-property',
    mainComponentTypes: 'equipment-types',
    globalDocuments: 'global-documents',
    timeReportTypes: 'time-report-types',
    license: 'license',
    news: 'news',
    equipmentMigration: 'equipment-migration',
    dataSync: 'data-sync',
    backgroundJobs: 'background-jobs',
    featureFlags: 'feature-flags',
  },
  Customer: {
    basePath: '/customer/:id/manage/*',
    apiAccess: 'api-access',
    accessControl: 'access-control',
    accessControls: 'access-controls',
    users: 'users',
    userResources: 'users/:userId/resources',
    workOrders: 'work-orders',
    vessels: 'vessels',
    aisVessels: 'ais-vessels',
    timeReports: 'time-reports',
    services: 'services',
    localities: 'localities',
    storages: 'storages',
    serviceStations: 'service-stations',
    createLocality: 'localities/new',
    updateLocality: 'localities/:localityId',
    localityGroup: 'locality-groups',
    serviceStationGroup: 'service-station-group',
    accessLevelGroups: 'access-level-groups',
    createAccessLevelGroup: 'access-level-groups/new',
    updateAccessLevelGroup: 'access-level-groups/:id',
    userInvites: 'user-invites',
    customProperty: 'custom-property',
    mainComponentTypes: 'equipment-types',
    documentCategories: 'document-categories',
    checklistTemplates: 'checklist-templates',
    addChecklistTemplate: 'checklist-templates/new',
    editChecklistTemplate: 'checklist-templates/:checklistTemplateId/edit',
    formGenerator: 'form-generator',
    formSchemas: 'form-schemas',
    editFormSchema: 'form-schemas/:formSchemaId/edit',
    formSchemaReports: 'form-schema-reports',
    dynamicReports: 'dynamic-reports',
    mainComponents: 'equipment',
    mainComponent: 'equipment/:mainComponentId',
    deviation: 'deviations/:deviationId',
    deviationsAdmin: 'deviations-admin',
    newsAdmin: 'news-admin',
    globalDocumentsAdmin: 'global-documents-admin',
    globalDocumentsCustomer: 'global-documents-customer',
    suppliers: 'suppliers',
    document: 'documents/:documentId',
    interactiveSchemas: 'interactive-schemas',
    createInteractiveSchema: 'interactive-schemas/create',
    editInteractiveSchema: 'interactive-schemas/:schemaId/edit',
    checklists: 'checklists',
    createChecklist: 'checklists/create',
    editChecklist: 'checklists/:checklistId/edit',
    archivedDocuments: 'archived-documents',
    componentOverview: 'component-overview',
    projects: 'projects',
    localityGlobalDocuments: 'global-documents-locality',
  },
  Project: {
    main: '/project',
    basePath: '/projects/customer/:customerId/localities/:localityId/project/:projectId/*',
    project: '',
    workAssignments: 'work-assignments',
    workAssignment: 'work-assignments/:workAssignmentId',
    batchNumbers: 'batch-numbers',
  },
  ProjectAdmin: {
    main: '/projects/admin',
    basePath: '/projects/admin/*',
    users: 'users',
    customers: 'customers',
  },
  CertificateDatabase: '/certificate-database',
}

export const AppRoutesNavigation = {
  Home: '/',
  Login: '/login',
  Vessel: process.env.REACT_APP_VESSEL_URL || '',
  Profile: '/profile',
  UserRegistration: (code: string) => `/register/${code}`,
  RegisterComplete: '/register/complete',
  UnAuth: '/unauth',
  Localities: {
    basePath: '/localities',
    main: '/locality',
    locality: (customerId: EntityId, localityId: EntityId) =>
      `/localities/customer/${customerId}/locality/${localityId}?#locality-${localityId}`,
    deviations: (customerId: EntityId, localityId: EntityId) =>
      `/localities/customer/${customerId}/locality/${localityId}/deviations`,
    deviation: (customerId: EntityId, localityId: EntityId, deviationId: EntityId) =>
      `/localities/customer/${customerId}/locality/${localityId}/deviations/${deviationId}`,
    componentDeviations: (
      customerId: EntityId,
      localityId: EntityId,
      mooringId: EntityId,
      positionId: EntityId,
      componentId: EntityId,
    ) =>
      `/localities/customer/${customerId}/locality/${localityId}/moorings/${mooringId}/positions/${positionId}/components/${componentId}/deviations`,
    documents: (customerId: EntityId, localityId: EntityId) =>
      `/localities/customer/${customerId}/locality/${localityId}/documents`,
    document: (customerId: EntityId, localityId: EntityId, documentId: EntityId) =>
      `/localities/customer/${customerId}/locality/${localityId}/documents/${documentId}`,
    mainComponent: (customerId: EntityId, localityId: EntityId, mainComponentId: EntityId) =>
      `/localities/customer/${customerId}/locality/${localityId}/equipment/${mainComponentId}`,
    moorings: (customerId: EntityId, localityId: EntityId) =>
      `/localities/customer/${customerId}/locality/${localityId}/moorings`,
    mooringsDashboard: (customerId: EntityId, localityId: EntityId) =>
      `/localities/customer/${customerId}/locality/${localityId}/moorings/dashboard`,
    mooringsList: (customerId: EntityId, localityId: EntityId) =>
      `/localities/customer/${customerId}/locality/${localityId}/moorings/list`,
    positions: (customerId: EntityId, localityId: EntityId, mooringId: EntityId) =>
      `/localities/customer/${customerId}/locality/${localityId}/moorings/${mooringId}/positions`,
    mooringMap: (customerId: EntityId, localityId: EntityId, mooringId: EntityId) =>
      `/localities/customer/${customerId}/locality/${localityId}/moorings/${mooringId}`,
    position: (customerId: EntityId, localityId: EntityId, mooringId: EntityId, positionId: EntityId) =>
      `/localities/customer/${customerId}/locality/${localityId}/moorings/${mooringId}/positions/${positionId}`,
    createPosition: (customerId: EntityId, localityId: EntityId, id: EntityId) =>
      `/localities/customer/${customerId}/locality/${localityId}/moorings/${id}/position/create`,
    localityServices: (customerId: EntityId, localityId: EntityId) =>
      `/localities/customer/${customerId}/locality/${localityId}/locality-services`,
    localityService: (customerId: EntityId, localityId: EntityId, localityFrequencyId: EntityId) =>
      `/localities/customer/${customerId}/locality/${localityId}/locality-services/${localityFrequencyId}`,
    localityServiceGroup: (customerId: EntityId, localityId: EntityId, groupId: string) =>
      `/localities/customer/${customerId}/locality/${localityId}/locality-services-group/${groupId}`,
    workAssignments: (customerId: EntityId, localityId: EntityId) =>
      `/localities/customer/${customerId}/locality/${localityId}/work-assignments`,
    workAssignment: (customerId: EntityId, localityId: EntityId, workAssignmentId: EntityId) =>
      `/localities/customer/${customerId}/locality/${localityId}/work-assignments/${workAssignmentId}`,
    equipment: (customerId: EntityId, localityId: EntityId) =>
      `/localities/customer/${customerId}/locality/${localityId}/equipment`,
    workOrders: (customerId: EntityId, localityId: EntityId) =>
      `/localities/customer/${customerId}/locality/${localityId}/work-orders`,
    workOrder: (customerId: EntityId, localityId: EntityId, workorderId: EntityId) =>
      `/localities/customer/${customerId}/locality/${localityId}/work-orders/${workorderId}`,
    equipmentPerformedMaintenances: (customerId: EntityId, localityId: EntityId) =>
      `/localities/customer/${customerId}/locality/${localityId}/equipment-performed-maintenances`,
    localityPerformedMaintenances: (customerId: EntityId, localityId: EntityId) =>
      `/localities/customer/${customerId}/locality/${localityId}/locality-performed-maintenances`,
  },
  serviceStation: {
    basePath: '/service-stations',
    main: '/service-station',
    serviceStation: (customerId: EntityId, serviceStationId: EntityId) =>
      `/service-stations/customer/${customerId}/service-station/${serviceStationId}`,
    dashboard: (customerId: EntityId, serviceStationId: EntityId) =>
      `/service-stations/customer/${customerId}/service-station/${serviceStationId}/dashboard`,
    deviation: (customerId: EntityId, serviceStationId: EntityId, deviationId: EntityId) =>
      `/service-stations/customer/${customerId}/service-station/${serviceStationId}/deviations/${deviationId}`,
    document: (customerId: EntityId, serviceStationId: EntityId, documentId: EntityId) =>
      `/service-stations/customer/${customerId}/service-station/${serviceStationId}/documents/${documentId}`,
    certifications: (customerId: EntityId, serviceStationId: EntityId) =>
      `/service-stations/customer/${customerId}/service-station/${serviceStationId}/certifications`,
    mainComponent: (serviceStationId: EntityId, customerId: EntityId, mainComponentId: EntityId) =>
      `/service-stations/customer/${customerId}/service-station/${serviceStationId}/equipment/${mainComponentId}`,
    history: (customerId: EntityId, serviceStationId: EntityId) =>
      `/service-stations/customer/${customerId}/service-station/${serviceStationId}/history`,
  },
  storage: {
    basePath: '/storages',
    main: '/storage',
    storage: (customerId: EntityId, storageId: EntityId) => `/storages/customer/${customerId}/storage/${storageId}`,
    deviation: (customerId: EntityId, storageId: EntityId, deviationId: EntityId) =>
      `/storages/customer/${customerId}/storage/${storageId}/deviations/${deviationId}`,
    document: (customerId: EntityId, storageId: EntityId, documentId: EntityId) =>
      `/storages/customer/${customerId}/storage/${storageId}/documents/${documentId}`,
  },
  Boats: '/boats',
  Map: '/map',
  Admin: {
    basePath: '/admin',
    users: '/admin/all-users',
    customers: '/admin/customers',
    createCustomer: '/admin/customers/create',
    updateCustomer: (id: EntityId) => `/admin/customers/${id}`,
    customerUsers: (id: EntityId) => `/admin/customers/${id}/users`,
    customerUserResources: (id: EntityId, userId: string) => `/admin/customers/${id}/users/${userId}/resources`,
    materialFactor: '/admin/material-factor',
    deviations: '/admin/deviations',
    deviation: (deviationId: EntityId) => `/admin/deviations/${deviationId}`,
    document: (documentId: EntityId) => `/admin/documents/${documentId}`,
    product: '/admin/product',
    productCategory: '/admin/productCategory',
    supplier: '/admin/supplier',
    accessControl: '/admin/access-control',
    sensorType: '/admin/sensor-type',
    distributor: '/admin/distributor',
    positionDrawing: '/admin/position-drawing',
    documentCategory: '/admin/document-category',
    auditLogs: '/admin/audit-logs',
    customProperty: '/admin/custom-property',
    mainComponentTypes: '/admin/equipment-types',
    globalDocuments: '/admin/global-documents',
    timeReportTypes: '/admin/time-report-types',
    license: '/admin/license',
    news: '/admin/news',
    equipmentMigration: '/admin/equipment-migration',
    dataSync: '/admin/data-sync',
    backgroundJobs: '/admin/background-jobs',
    featureFlags: '/admin/feature-flags',
  },
  Customer: {
    basePath: (id: EntityId) => `/customer/${id}/manage`,
    apiAccess: (id: EntityId) => `/customer/${id}/manage/api-access`,
    accessControls: (id: EntityId) => `/customer/${id}/manage/access-controls`,
    globalDocumentsAdmin: (id: EntityId) => `/customer/${id}/manage/global-documents-admin`,
    globalDocumentsCustomer: (id: EntityId) => `/customer/${id}/manage/global-documents-customer`,
    document: (customerId: EntityId, documentId: EntityId) => `/customer/${customerId}/manage/documents/${documentId}`,
    customerGlobalDocuments: (id: EntityId) => `/customer/${id}/manage/global-documents`,
    suppliers: (id: EntityId) => `/customer/${id}/manage/suppliers`,
    users: (id: EntityId) => `/customer/${id}/manage/users`,
    userResources: (customerId: EntityId, id: EntityId) => `/customer/${customerId}/manage/users/${id}/resources`,
    services: (id: EntityId) => `/customer/${id}/manage/services`,
    localities: (id: EntityId) => `/customer/${id}/manage/localities`,
    storages: (id: EntityId) => `/customer/${id}/manage/storages`,
    projects: (id: EntityId) => `/customer/${id}/manage/projects`,
    serviceStations: (id: EntityId) => `/customer/${id}/manage/service-stations`,
    createLocality: (id: EntityId) => `/customer/${id}/manage/localities/new`,
    updateLocality: (customerId: EntityId, id: EntityId) => `/customer/${customerId}/manage/localities/${id}`,
    localityGroups: (id: EntityId) => `/customer/${id}/manage/locality-groups`,
    serviceStationGroup: (id: EntityId) => `/customer/${id}/manage/service-station-group`,
    accessLevelGroups: (customerId: EntityId) => `/customer/${customerId}/manage/access-level-groups`,
    createAccessLevelGroup: (customerId: EntityId) => `/customer/${customerId}/manage/access-level-groups/new`,
    updateAccessLevelGroup: (customerId: EntityId, id: EntityId) =>
      `/customer/${customerId}/manage/access-level-groups/${id}`,
    userInvites: (customerId: EntityId) => `/customer/${customerId}/manage/user-invites`,
    userInvite: (customerId: EntityId, id: EntityId) => `/customer/${customerId}/manage/user-invites/${id}`,
    customProperty: (customerId: EntityId) => `/customer/${customerId}/manage/custom-property`,
    mainComponentTypes: (customerId: EntityId) => `/customer/${customerId}/manage/equipment-types`,
    documentCategories: (customerId: EntityId) => `/customer/${customerId}/manage/document-categories`,
    checklistTemplates: (customerId: EntityId) => `/customer/${customerId}/manage/checklist-templates`,
    addChecklistTemplate: (customerId: EntityId) => `/customer/${customerId}/manage/checklist-templates/new`,
    editChecklistTemplate: (customerId: EntityId, checklistTemplateId: EntityId) =>
      `/customer/${customerId}/manage/checklist-templates/${checklistTemplateId}/edit`,
    formGenerator: (customerId: EntityId) => `/customer/${customerId}/manage/form-generator`,
    formSchema: (customerId: EntityId) => `/customer/${customerId}/manage/form-schemas`,
    editFormSchema: (customerId: EntityId, formSchemaId: number) =>
      `/customer/${customerId}/manage/form-schemas/${formSchemaId}/edit`,
    formSchemaReports: (customerId: EntityId) => `/customer/${customerId}/manage/form-schema-reports`,
    dynamicReports: (customerId: EntityId) => `/customer/${customerId}/manage/dynamic-reports`,
    mainComponents: (customerId: EntityId) => `/customer/${customerId}/manage/equipment`,
    workOrders: (customerId: EntityId) => `/customer/${customerId}/manage/work-orders`,
    vessels: (customerId: EntityId) => `/customer/${customerId}/manage/vessels`,
    aisVessels: (customerId: EntityId) => `/customer/${customerId}/manage/ais-vessels`,
    timeReports: (customerId: EntityId) => `/customer/${customerId}/manage/time-reports`,
    mainComponent: (customerId: EntityId, mainComponentId: EntityId) =>
      `/customer/${customerId}/manage/equipment/${mainComponentId}`,
    deviation: (customerId: EntityId, deviationId: EntityId) =>
      `/customer/${customerId}/manage/deviations/${deviationId}`,
    interactiveSchemas: (customerId: EntityId) => `/customer/${customerId}/manage/interactive-schemas`,
    createInteractiveSchema: (customerId: EntityId) => `/customer/${customerId}/manage/interactive-schemas/create`,
    editInteractiveSchema: (customerId: EntityId, schemaId: EntityId) =>
      `/customer/${customerId}/manage/interactive-schemas/${schemaId}/edit`,
    checklists: (customerId: EntityId) => `/customer/${customerId}/manage/checklists`,
    createChecklist: (customerId: EntityId) => `/customer/${customerId}/manage/checklists/create`,
    editChecklist: (customerId: EntityId, checklistId: EntityId) =>
      `/customer/${customerId}/manage/checklists/${checklistId}/edit`,
    newsAdmin: (id: EntityId) => `/customer/${id}/manage/news-admin`,
    deviationsAdmin: (id: EntityId) => `/customer/${id}/manage/deviations-admin`,
    archivedDocuments: (id: EntityId) => `/customer/${id}/manage/archived-documents`,
    componentOverview: (id: EntityId) => `/customer/${id}/manage/component-overview`,
    localityGlobalDocuments: (customerId: EntityId) => `/customer/${customerId}/manage/global-documents-locality`,
  },
  CertificateDatabase: '/certificate-database',
  Project: {
    basePath: '/projects',
    main: '/project',
    project: (customerId: EntityId, localityId: EntityId, projectId: EntityId) =>
      `/projects/customer/${customerId}/localities/${localityId}/project/${projectId}`,
    workAssignments: (customerId: EntityId, localityId: EntityId, projectId: EntityId) =>
      `/projects/customer/${customerId}/localities/${localityId}/project/${projectId}/work-assignments`,
    workAssignment: (customerId: EntityId, localityId: EntityId, projectId: EntityId, workAssignmentId: EntityId) =>
      `/projects/customer/${customerId}/localities/${localityId}/project/${projectId}/work-assignments/${workAssignmentId}`,
    batchNumbers: (customerId: EntityId, localityId: EntityId, projectId: EntityId) =>
      `/projects/customer/${customerId}/localities/${localityId}/project/${projectId}/batch-numbers`,
  },
  ProjectAdmin: {
    basePath: '/projects/admin',
    users: '/projects/admin/users',
    customers: '/projects/admin/customers',
  },
}
